<template>
    <div>
        <div class="table-responsive">
            <table class="table-make w-100 bg-blanco table-hover table-composiciones">
                <thead>
                <tr>
                    <th><span class="texto-gris">Mis Saludos</span> <br> <span class="font-10">En los últimos días</span></th>
                    <th>Última modifcación</th>
                    <th width="180" class="text-center">Acciones</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(composicion, key) in composiciones">
                    <td>{{composicion.nombre}}</td>
                    <td width="250">{{composicion.ultima_modificacion}}</td>
                    <td width="180" align="center">
                        <a title="Ver" target="_blank" v-bind:href="appurl+'ver-maketa/'+composicion.codigo_hash+'/'+composicion.codigo_last_version+'/'+mkus_token" class="btn btn-gris p-1 texto-blanco mx-1"><i class="icon-visualizar"></i></a>
                        <a title="Editar" v-bind:href="appurl+'editar-maketa/'+composicion.codigo_hash" class="btn btn-morado-base p-1 texto-blanco mx-1"><i class="icon-lapiz"></i></a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="cnt-pagination mt-3">
            <nav class="d-flex">
                <div id="prev-pagination"></div>
                <ul id="pagination-bar" class="pagination-make"></ul>
                <div id="next-pagination"></div>
            </nav>
        </div>
    </div>
</template>
<script>
    import { modalnotificaciones } from '@resources/helpers.js'
    const instance = axios.create({
        headers: {'Authorization': 'Bearer '+document.querySelector("#mkap_token").value}
    });
    export default {
        data (){
            return {
                composiciones: [],
                totalpaginas: 0,
                mkus_token: document.querySelector("#mkus_token").value,
                appurl: document.querySelector("#app_url").value
            }
        },
        mounted () {
            instance.post('obtenercomposiciones', {
                token : this.mkus_token,
                codigo_board : '',
                pagina : 1,
                filtro : "",
                etiquetas : "",
                order : "DESC",
                orderby : "updated_at",
                orderent : "v2"
            })
                .then(response => {
                    this.composiciones = response.data.composiciones
                    this.totalpaginas = response.data.total_paginas
                })
                .catch(error => {
                    modalnotificaciones('Aviso', 'Verifique su conexion a internet', '', '', '#modalavisoindex')
                })
                .finally(

                )
        },
        methods: {
            modalIngresarCorreo(key){
                let self = this
                console.log(self.composiciones[key].codigo_hash)
                console.log(self.composiciones[key].codigo_version)
            },
            enviarCorreo (key){
                let self = this
                instance.post('version/enviarmail', {
                    token : document.querySelector("#mkus_token").value,
                    codigo_composicion : self.composiciones[key].codigo_hash,
                    codigo_version : self.composiciones[key].codigo_version,
                    correos_envio : 'junfig@beta.pe',
                    asunto: "Asunto t",
                    tipo_mail: "C"
                })
                    .then(response => {
                        modalnotificaciones('Aviso', 'Se ha enviando el correo', '', '', '#modalavisoindex')
                    })
                    .catch(error => {
                        modalnotificaciones('Aviso', 'No se pudo enviar el correo', '', '', '#modalavisoindex')
                    })
            }
        }
    }
</script>
